import { Button, FormHelperText, Grid } from '@mui/material';
import { useCallback } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { defaultOrderNote } from 'shared/constants';
import { OrderNotesFields } from './order-notes-fields';

export function OrderNotesInfo() {
  const {
    watch,
    formState: { errors },
  } = useFormContext();
  const { fields, append, remove } = useFieldArray({
    name: 'orderNotes',
  });
  const watchOrderNotes = watch('orderNotes');
  const controlledFields = fields.map((field, index) => ({
    ...field,
    ...watchOrderNotes[index],
  }));

  const addOrderNote = useCallback(() => {
    append(defaultOrderNote);
  }, [append]);

  const removeOrderNote = (index: number) => () => {
    remove(index);
  };

  return (
    <Grid container spacing={2} direction='column'>
      <Grid item>
        <Button onClick={addOrderNote} variant='contained'>
          Add Order Notes
        </Button>
      </Grid>
      <Grid item xs={12}>
        <Grid container spacing={1}>
          {controlledFields.map((field, index) => (
            <OrderNotesFields
              key={field.id}
              index={index}
              remove={removeOrderNote}
              isLastOrderNote={index === controlledFields.length - 1}
              addOrderNote={addOrderNote}
            />
          ))}
        </Grid>
        <Grid xs={12} item>
          <FormHelperText error>{errors?.orderNotes?.message}</FormHelperText>
        </Grid>
      </Grid>
    </Grid>
  );
}
